<template>
  <v-dialog v-model="visible" width="670" style="height: 572px" persistent>
    <div class="sib-form pb-12" style="text-align: center; background-color: #eff2f7">
      <div class="text-right mt-n4">
        <v-btn icon @click="onClose">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

<iframe width="550" height="550" src="https://26142d87.sibforms.com/serve/MUIEALUJT78eFzy43xY9c_ybselFvBqgz4S4tUv4nKdi_XkJUJCmyk-fgMf2ijHAvL3yUGPbc7NItO2g8XxiZVC6SHNYE0D_wBPghHNqwohubvofk3TwuRFxm2sx42RlV9izNXJkSL9DMQrrW2mljeYkJI8XRXV7f2qnoaNcK3q8I3TYof2Z0-EGtfxZIyOnYjRQTr3XgW2MyPau" frameborder="0" scrolling="auto" allowfullscreen style="display: block;margin-left: auto;margin-right: auto;max-width: 100%;"></iframe>

    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "NewsLetter",
  props: ["visible"],
  methods: {
    onClose() {
      this.$emit("onClose");
    },
  },
};
</script>

<style>
@font-face {
  font-display: block;
  font-family: Roboto;
  src: url(https://assets.sendinblue.com/font/Roboto/Latin/normal/normal/7529907e9eaf8ebb5220c5f9850e3811.woff2)
      format("woff2"),
    url(https://assets.sendinblue.com/font/Roboto/Latin/normal/normal/25c678feafdc175a70922a116c9be3e7.woff)
      format("woff");
}

@font-face {
  font-display: fallback;
  font-family: Roboto;
  font-weight: 600;
  src: url(https://assets.sendinblue.com/font/Roboto/Latin/medium/normal/6e9caeeafb1f3491be3e32744bc30440.woff2)
      format("woff2"),
    url(https://assets.sendinblue.com/font/Roboto/Latin/medium/normal/71501f0d8d5aa95960f6475d5487d4c2.woff)
      format("woff");
}

@font-face {
  font-display: fallback;
  font-family: Roboto;
  font-weight: 700;
  src: url(https://assets.sendinblue.com/font/Roboto/Latin/bold/normal/3ef7cf158f310cf752d5ad08cd0e7e60.woff2)
      format("woff2"),
    url(https://assets.sendinblue.com/font/Roboto/Latin/bold/normal/ece3a1d82f18b60bcce0211725c476aa.woff)
      format("woff");
}

#sib-container input:-ms-input-placeholder {
  text-align: left;
  font-family: "Helvetica", sans-serif;
  color: #c0ccda;
}

#sib-container input::placeholder {
  text-align: left;
  font-family: "Helvetica", sans-serif;
  color: #c0ccda;
}
.application--dialog-opened {
  overflow: hidden;
}
</style>
